/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import useStyles from "./styles";
import HeaderPage from "components/PageContainer/components/HeaderPage";
import FooterPage from "components/PageContainer/components/FooterPage";
import LoadingPage from "components/LoadingPage";
import AlertMessage from "components/AlertMessage";

import { Grid } from "@material-ui/core";
import { connect } from "react-redux";
import { setAlertMessage } from "store/actions/GlobalAction";
import { logoutRequest } from "store/actions/LoginPageAction";
import { useHistory, useLocation } from "react-router-dom";
import { REDIRECT_CHANGE_PASSWORD } from "config/constant";
import { getIsSkip } from "utils/utils";

const PageContainer = props => {
	const classes = useStyles();
	const {
		children,
		isLoading,
		isOpenAlert,
		isError,
		message,
		setAlertMessage,
		infoShop,
		logout
	} = props;

	const history = useHistory();
	const location = useLocation();
	const { pathname } = location;

	const passwordType = infoShop?.passwordType;
	const business = infoShop?.business;

	const isSkip = getIsSkip();

	useEffect(() => {
		if (
			Object.keys(infoShop).length !== 0 &&
			REDIRECT_CHANGE_PASSWORD.includes(passwordType) &&
			infoShop?.statusRegisterDevice === "APPROVED" &&
			pathname !== "/splash"
		) {
			if (passwordType === "ABOUT_TO_EXPIRE") {
				if (!isSkip) {
					localStorage.setItem("isSkipChangePassword", true);
					history.push("/change_password");
				}
			} else {
				history.push("/change_password");
			}
		}
	}, [passwordType, isSkip, pathname]);

	const closeAlert = () => {
		const alert = {
			isOpenAlert: false,
			isError: false,
			message: ""
		};
		setAlertMessage(alert);
	};

	useEffect(() => {
		if (isOpenAlert) {
			setTimeout(() => {
				closeAlert();
			}, 3000);
		}
	}, [isOpenAlert]);

	return (
		<Grid classes={{ root: classes.rootPage }}>
			{/* isSkip:{isSkip} - passwordType: {passwordType} */}
			{isLoading && pathname !== "/splash" && <LoadingPage />}
			<HeaderPage passwordType={passwordType} logout={logout} />
			{isOpenAlert && (
				<AlertMessage
					isError={isError}
					message={message}
					handleCloseAlert={closeAlert}
				/>
			)}
			<Grid style={{ overflow: "hidden" }}>{children}</Grid>
			{Object.keys(infoShop).length !== 0 && (
				<FooterPage business={business} />
			)}
		</Grid>
	);
};

const mapStateToProps = state => {
	return {
		isLoading: state.globalReducer.isLoading,
		isOpenAlert: state.globalReducer.isOpenAlert,
		isError: state.globalReducer.isError,
		message: state.globalReducer.message,
		infoShop: state.homePageReducer.infoShop
	};
};

const mapDispatchToProps = dispatch => {
	return {
		setAlertMessage: params => {
			dispatch(setAlertMessage(params));
		},
		logout: () => {
			dispatch(logoutRequest());
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(PageContainer);
